export interface IFormSubmitService {
  submitForm(form: HTMLFormElement): void;
}
export class FormSubmitService implements IFormSubmitService {
  submitForm(form: HTMLFormElement) {
    form.submit();
  }
}
export const FormSubmitServiceToken = Symbol(FormSubmitService.name);
